import React from 'react'
import { OrderData } from '../../../services/api/orders'
import {
  Order,
  Flight,
  Passengers,
  CreateRefund,
  Refund,
  CopyOrderData,
} from './components'
import {
  Button,
  Descriptions,
  Divider,
  Modal,
  Space,
  Tooltip,
  Typography,
  Card,
  Row,
  Col,
} from 'antd'
import { DollarCircleFilled, SyncOutlined } from '@ant-design/icons'

type Props = {
  order: OrderData

  checkoutAllowed: boolean
  checkoutOrder: () => void

  refunded: boolean
  refundAllowed: boolean
  setIsRefundVisible: (visibility: boolean) => void
  isRefundVisible: boolean
  onRefund: () => void
}
const { Title } = Typography
const { Item } = Descriptions

export const View: React.FunctionComponent<Props> = ({
  order,

  checkoutOrder,
  checkoutAllowed,

  refunded,
  refundAllowed,
  setIsRefundVisible,
  isRefundVisible,
  onRefund,
}) => {
  return (
    <>
      <Card size="small">
        <Row justify="space-between" align="bottom">
          <Col>
            <Title level={4} style={{ padding: 0, margin: 0 }}>
              Заказ {order.number}
            </Title>
          </Col>
          <Col>
            <Space size={10}>
              <CopyOrderData order={order} />

              {checkoutAllowed ? (
                <Button
                  type="primary"
                  danger
                  onClick={() => {
                    checkoutOrder()
                  }}
                >
                  <DollarCircleFilled />
                  Оплатить повторно
                </Button>
              ) : (
                <Tooltip title="Доступно только для failed заказов, дата вылета которых не истекла">
                  <Button type="primary" danger disabled>
                    <DollarCircleFilled />
                    Оплатить повторно
                  </Button>
                </Tooltip>
              )}

              {refundAllowed ? (
                <Button
                  type="primary"
                  danger
                  onClick={() => setIsRefundVisible(true)}
                >
                  <SyncOutlined />
                  Возврат
                </Button>
              ) : (
                <Tooltip title="Доступно только для failed и completed заказов, дата вылета которых не истекла">
                  <Button type="primary" danger disabled>
                    <SyncOutlined />
                    Возврат
                  </Button>
                </Tooltip>
              )}

              {refundAllowed && (
                <Modal
                  visible={isRefundVisible}
                  title="Возврат средств"
                  onCancel={() => setIsRefundVisible(false)}
                  footer={false}
                >
                  <CreateRefund order={order} onSuccess={onRefund} />
                </Modal>
              )}
            </Space>
          </Col>
        </Row>
      </Card>

      <Divider />

      <Descriptions
        bordered
        size="small"
        column={1}
        labelStyle={{ textAlign: 'right', width: '1%', whiteSpace: 'nowrap' }}
      >
        <Item label={<Title level={5}> Данные заказа </Title>}>
          <Order order={order} />
        </Item>
        <Item label={<Title level={5}> Данные о полете </Title>}>
          <Flight flight={order.flight} />
        </Item>
        <Item label={<Title level={5}> Данные о пассажирах </Title>}>
          <Passengers passengers={order.passengers} />
        </Item>
        {refunded && (
          <Item label={<Title level={5}> Данные о возврате </Title>}>
            <Refund order={order} />
          </Item>
        )}
      </Descriptions>
    </>
  )
}
